import { AgentFullData } from "@/entry/server/agents";
import { Movie, SearchFilterItem } from "@/entry/server/movie";
import { Pagination } from "@/lib/api";
import SectionTopBg from "@public/img/section-top-bg.png";
import PaginationView from "@/component/commom/pagination";
import { ASSETS_BASE_URL } from "@/utils/constants";
import { videoRepo } from "@/repo/video-repo";
import React, { useEffect, useState } from "react";
import SelectField from "@/component/widgets/select-field";
import MovieCard from "@/component/commom/movie-card";
import "@/styles/agents.css";

type AgentsDetailsProps = {
    type: "directors" | "actors"
    info: AgentFullData;
    movies: Movie[];
    pagination: Pagination;
}

const sortOptions = [
  { label: "مرتب سازی", value: "" },
  { label: "جدیدترین", value: "newest" },
  { label: "پر بازدیدترین", value: "most-viewed" },
  { label: "امتیاز Imdb", value: "imdb-rating" },
  { label: "سال انتشار", value: "release-year" },
] as SearchFilterItem[];

const imdbRatingOptions = [
  { label: "امتیاز Imdb", value: "" },
  { label: "بالاتر از 9.0", value: "9.0" },
  { label: "بالاتر از 8.0", value: "8.0" },
  { label: "بالاتر از 7.0", value: "7.0" },
  { label: "بالاتر از 6.0", value: "6.0" },
  { label: "بالاتر از 5.0", value: "5.0" },
] as SearchFilterItem[];

export default function AgentsDetails({ type, info, movies, pagination }: AgentsDetailsProps) {
    const posterSrc = info.image_url.startsWith("http") ? info.image_url : `${ASSETS_BASE_URL}${info.image_url}`;
    const onPageChange = async (page: number) => {
        const url = new URL(window.location.href);
        url.searchParams.set("page", page.toString());
        window.history.pushState({}, "", url.toString());
    }

    const [genreOptions, setGenreOptions] = useState<SearchFilterItem[]>([]);

    useEffect(() => {
        videoRepo.getSearchFilters().then((res) => {
            if (res.data && res.data.genres) {
                setGenreOptions(res.data.genres);
            }
        });
    }, []);

    return (
        <div role="main" className="agent-detail">
            <div className="agent-detail__hero">
                <img src={SectionTopBg} alt="" className="agent-detail__hero-bg" />
                <div className="agent-detail__hero-inner">
                    <div className="agent-detail__avatar-wrap">
                        <img src={posterSrc} alt={info.name} className="agent-detail__avatar" />
                    </div>
                    <div className="agent-detail__info-card" id="agent-info">
                        <div className="agent-detail__info-text">
                            <h1 className="agent-detail__name">{info.name}</h1>
                            <p className="agent-detail__meta">تولد: {info.birth_date}</p>
                            <p className="agent-detail__meta">محل تولد: {info.birth_place}</p>
                        </div>

                        {genreOptions.length > 0 ? (
                            <div className="agent-detail__filters">
                                <SelectField uniqueKey="genre" options={genreOptions} onChange={() => {}} value="" />
                                <SelectField uniqueKey="imdb-rating" options={imdbRatingOptions} onChange={() => {}} value="" />
                                <SelectField uniqueKey="sort" options={sortOptions} onChange={() => {}} value="" />
                            </div>
                        ) : (
                            <div className="agent-detail__filters">
                                <div className="shimmer"></div>
                                <div className="shimmer"></div>
                                <div className="shimmer"></div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="agent-detail__movies">
                {movies.map(function (movie) {
                    return (
                    <div key={movie.id} className="agent-detail__movie-item">
                        <MovieCard
                            id={movie.id}
                            slug={movie.slug}
                            type={movie.type}
                            title={movie.title}
                            updateText={movie.update_text}
                            year={movie.year != null ? String(movie.year) : ""}
                            ratingValue={movie.imdb_rate != null ? String(movie.imdb_rate) : "0"}
                            thumbnail={movie.thumbnail}
                            isDubbed={movie.is_dubbed}
                            isSubtitled={movie.is_subbed}
                            genres={movie.genres ? movie.genres : []}
                        />
                    </div>
                    );
                })}
            </div>
            <div className="agent-detail__pagination">
                <PaginationView pagination={pagination} onChange={onPageChange} />
            </div>
        </div>
    )
}
